import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Input, Renderer2, ElementRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video',
  templateUrl: 'video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['video.component.scss']
})

export class VideoComponent implements OnInit, OnChanges {
  public cdn = environment.cdn;
  public movie: any = [];
  public mediaSource: MediaSource;
  public chunk = 1048576; //1mb bin
  public chunks = 0; //1mb bin
  public totalBytes: number = 0;
  public arrayOfBlobs = [];
  public isInited = false;
  public isplaying = false;
  public url: string = '';
  public width: number;
  public height: number;
  public video_positioner: HTMLVideoElement;
  public video: HTMLVideoElement;
  public play: HTMLButtonElement;
  public pause: HTMLButtonElement;
  public codec = 'video/mp4;';
  public isMediaStream = true;
  @Input() public title: '';
  @Input() public urls: any[] = [];
  @Input() public load: boolean = true;
  @Input() public autoplay: boolean = true;
  @Input() public playPause: boolean = false;
  @Input() public loop: boolean = true;
  @Input() public showCtrls: boolean = true;
  @Input() public poster: string;
  @Input() public fit: boolean = true;
  @Input() public mediaStremEnabled: boolean = true;
  @Input() public muted: boolean = true;
  @Output() videoEnd = new EventEmitter<boolean>();
  @Output() videoPlay = new EventEmitter<boolean>();
  
  constructor(private video_wrap:ElementRef, private renderer: Renderer2, private cdr: ChangeDetectorRef, private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {    
    this.breakpointObserver
    .observe(['(min-width: 1279px)'])
    .subscribe((state: BreakpointState) => {

      let i = 0;

      if (state.matches) {
        i = 0;
        // this.cdr.markForCheck();
        // Viewport is 500px or over!
      } else {
        if (this.urls.length > 1) {
          i = 1;
        } else {
          i = 0;
        }
        // this.cdr.markForCheck();
        // Viewport is getting smaller!
      }

      
      let url = this.urls[i].u;
      this.width = this.urls[i].w;
      this.height = this.urls[i].h;
      
      if (this.url != url && this.width && this.height) {
        this.url = url;

        if ('MediaSource' in window && MediaSource.isTypeSupported(this.codec)) {
          this.isMediaStream = this.mediaStremEnabled;
        } else {
          this.isMediaStream = false;
        }

        this.video_positioner = this.renderer.createElement('div');
        this.video = this.renderer.createElement('video');
        this.video.muted = this.muted;
        if (this.poster) this.video.poster = this.poster;
        this.video.loop = this.loop;
        this.video.playsInline = true;
        this.video.preload = 'none';
        this.video.controls = false;
        if (this.fit) {
        this.renderer.addClass(this.video_wrap.nativeElement, 'fit');
        }
    
        this.renderer.appendChild(this.video_wrap.nativeElement, this.video_positioner);
        this.renderer.appendChild(this.video_positioner, this.video);

        if (this.showCtrls) {
          this.play = this.renderer.createElement('button');
          this.renderer.addClass(this.play, 'product-video-play');
          const play_icon = this.renderer.createElement('img');
          play_icon.src = '/assets/play_video_white.svg';
          this.renderer.appendChild(this.play, play_icon);
          this.renderer.appendChild(this.video_positioner, this.play);
      
          this.renderer.listen(this.play, 'click', (event) => {
            if (this.load) {
              this.video.play();
              this.isplaying = true;
              this.renderer.addClass(this.play, 'hidden');
              this.renderer.removeClass(this.pause, 'hidden');
              if ((<any>window).dataLayer) {
                (<any>window).dataLayer.push({
                  event: 'video',
                  video_status: 'play',
                  video_title: this.title
                });
              }
            } else {
              this.initVideo();
            }
            this.videoPlay.emit(true);
          });


          this.pause = this.renderer.createElement('button');
          this.renderer.addClass(this.pause, 'product-video-pause');
          this.renderer.addClass(this.pause, 'hidden');
          this.renderer.appendChild(this.video_positioner, this.pause);

          this.renderer.listen(this.pause, 'click', (event) => {
              this.video.pause();
              this.isplaying = false;
              this.renderer.addClass(this.pause, 'hidden');
              this.renderer.removeClass(this.play, 'hidden');
              if ((<any>window).dataLayer) {
                (<any>window).dataLayer.push({
                  event: 'video',
                  video_status: 'pause',
                  video_title: this.title
                });
              }
          });
        }

        if (this.load) {
          this.initVideo();
        }
      }

    }); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.load) {
      if (changes.load.previousValue == false && changes.load.currentValue == true && !this.isplaying && !this.isInited) {
        //console.log('cmp init video');
        this.initVideo();
      } else if (changes.load.previousValue == true && changes.load.currentValue == false && this.isplaying ){
        //console.log('cmp stop video');
        this.isplaying = false;
        this.video.pause();
        if ((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'video',
            video_status: 'pause',
            video_title: this.title
          });
        }
        this.renderer.removeClass(this.play, 'hidden');
        // this.renderer.removeChild(this.video_wrap.nativeElement, this.video);
        // this.video = null;
      }
    }

    if (changes.playPause) {
      if (changes.playPause.previousValue == false && changes.playPause.currentValue == true) {
        //start
        this.video.play();
        this.isplaying = true;
        this.renderer.addClass(this.play, 'hidden');
        this.renderer.removeClass(this.pause, 'hidden');

        if ((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'video',
            video_status: 'play',
            video_title: this.title
          });
        }

        console.log('PLAY');
      } else if (changes.playPause.previousValue == true && changes.playPause.currentValue == false) {
        //stop
        this.video.pause();
        this.isplaying = false;
        this.renderer.removeClass(this.play, 'hidden');
        this.renderer.addClass(this.pause, 'hidden');
        console.log('PAUSE');

        if ((<any>window).dataLayer) {
          (<any>window).dataLayer.push({
            event: 'video',
            video_status: 'pause',
            video_title: this.title
          });
        }
      }
    }
  }

  initVideo() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API/Transcoding_assets_for_MSE
    // https://github.com/w3c/media-source/issues/216
    // 540x960
    // ffmpeg -y -nostdin -loglevel info -i spot.mp4 -c:v libx264 -strict -2 -preset slow -pix_fmt yuv420p -s 1280x720 -b 10M -an -tune zerolatency -movflags frag_keyframe+empty_moov+default_base_moof -frag_size 1000000 -min_frag_duration 500000 -f mov hero_720.mp4

    if (this.isplaying) {
      this.isplaying = false;
      this.video.pause();
      this.renderer.removeChild(this.video_positioner, this.video);
      this.video = null;

      if (this.isMediaStream) {
        // this.mediaSource.removeAllListeners('sourceopen');
        // this.mediaSource.removeAllListeners('updateend');
        // this.mediaSource.removeAllListeners('playing');
        const sourceBuffer = this.mediaSource.sourceBuffers[0];
        this.mediaSource.removeSourceBuffer(sourceBuffer);
      }
    }

    this.isInited = true;

    this.video.addEventListener('ended', () => {
      this.video.currentTime = 0;
      this.videoEnd.emit(true);
    }, false);

    if (this.isMediaStream) {

      this.mediaSource = new MediaSource();

      this.video.src = URL.createObjectURL(this.mediaSource);
      this.mediaSource.addEventListener('sourceopen', () => {

        URL.revokeObjectURL(this.video.src);
        const sourceBuffer = this.mediaSource.addSourceBuffer(this.codec); //
        sourceBuffer.mode = 'sequence';
        // console.log(this.buildBytes(0, this.chunk));
        fetch(this.url, { headers: { range: this.buildBytes(0, this.chunk) } })
          .then(response => {
            let range = response.headers.get("Content-Range").split('/');
            this.totalBytes = +range[1];
            this.chunks = Math.floor(this.totalBytes / this.chunk);
            return response.arrayBuffer()
          })
          .then(data => {

            sourceBuffer.addEventListener('updateend', () => {
              // console.log('updateend', this.mediaSource.duration, sourceBuffer.updating, this.mediaSource.readyState, this.chunks);
              // if (sourceBuffer.updating === false && sourceBuffer && this.mediaSource.readyState === "open") {
                if (this.chunks == 0) {
                  if (!sourceBuffer.updating && this.mediaSource.readyState === 'open') {
                  // console.log('ENDOFSTREAM');
                  this.mediaSource.endOfStream(); // end at
                  }
                } else {
                  // console.log('CHUNK', this.chunks);
                  this.chunks--;
                }
                if (this.video.paused) {
                  this.renderer.appendChild(this.video_positioner, this.video);
                  this.renderer.addClass(this.video_wrap.nativeElement, 'visible');
                  this.cdr.detectChanges();
                  if (this.autoplay) {
                    setTimeout(() => {
                      this.video.play();
                      this.isplaying = true;
                      if (this.showCtrls) {
                      this.renderer.addClass(this.play, 'hidden');
                      this.renderer.removeClass(this.pause, 'hidden');
                      if ((<any>window).dataLayer) {
                        (<any>window).dataLayer.push({
                          event: 'video',
                          video_status: 'play',
                          video_title: this.title
                        });
                      }
                      }
                    }, 500);
                  }
                }
              // }
            }, { once: false });

            sourceBuffer.appendBuffer(data);

          });

      }, { once: true });

      this.video.addEventListener('playing', () => this.getVideoStreamPart(
        this.chunk + 1,
        2 * this.chunk
      ), { once: true });

    } else {
      //iphone
      this.video.autoplay = this.autoplay;
      const source = this.renderer.createElement('source');
      source.src = this.url;
      this.renderer.appendChild(this.video, source);
      this.renderer.addClass(this.video_wrap.nativeElement, 'visible');     
      this.video.addEventListener('play', () => {
        this.isplaying = true;
        this.renderer.addClass(this.play, 'hidden');
      }, false);

    }

  }

  appendToSourceBuffer() {
    const sourceBuffer = this.mediaSource.sourceBuffers[0];

    // console.log('append', this.mediaSource.readyState, sourceBuffer.updating);

    if (
      this.mediaSource.readyState === "open" &&
      sourceBuffer &&
      sourceBuffer.updating === false
    ) {
      sourceBuffer.appendBuffer(this.arrayOfBlobs.shift());
    }

    // Limit the total buffer size to 20 minutes
    // This way we don't run out of RAM
    if (
      this.video.buffered.length &&
      this.video.buffered.end(0) - this.video.buffered.start(0) > 120
    ) {
      sourceBuffer.remove(0, this.video.buffered.end(0) - 120)
    }
  }

  getVideoStreamPart(
    start: number,
    end: number
  ) {
    // console.log(this.buildBytes(start, end));
    const response = fetch(this.url, { headers: { range: this.buildBytes(start, end) } })
      .then(response => response.arrayBuffer())
      .then(data => {

        this.arrayOfBlobs.push(data);
        this.appendToSourceBuffer();

        // console.log(end + this.chunk, this.totalBytes);
        if (end === this.totalBytes) {
          // console.log('DONE',  this.mediaSource.duration);
        } else if (end + this.chunk <= this.totalBytes) {
          // console.log('next');
          return this.getVideoStreamPart(end + 1, end + this.chunk);
        } else {
          // console.log('last');
          return this.getVideoStreamPart(end + 1, this.totalBytes);
        }
      }, () => {console.log('err')});
  }

  buildBytes(start: number, end: number): string {
    return `bytes=${start}-${end || ""}`;
  }
}